import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { Field } from 'formik';
import { TextField, Select } from 'formik-material-ui';
import { Grid, InputLabel, MenuItem, FormControl, FormHelperText, Button } from '@material-ui/core';
import { AttachFile, Delete } from '@material-ui/icons';
import useStyles from '../../Support-form.style';

const propTypes = {
    config: PropTypes.object,
    initialValues: PropTypes.object,
    errors: PropTypes.object
}

const FormComponent = ({ config, initialValues = {}, values, errors = {}, touched = {}, setFieldValue }) => {
    const classes = useStyles();
    const fileInput = useRef(null);

    const onFileSelection = (event) => {
        const value = event.target.files[0];
        setFieldValue('userFile', value);
    };

    const onSelectBtnClick = (existing) => {
        if (existing) return onUserFileClear();
        fileInput.current.click();
    };

    const onUserFileClear = () => {
        fileInput.current.value = '';
        setFieldValue('userFile', '');
    };

    return (
        <>
            <Grid item xs={12} sm={6}>
                <Field
                    component={TextField}
                    required
                    id="fName"
                    name="fName"
                    label={config.form.fName.label}
                    fullWidth
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <Field
                    component={TextField}
                    required
                    id="lName"
                    name="lName"
                    label={config.form.lName.label}
                    fullWidth
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <Field
                    component={TextField}
                    id="nickname"
                    name="nickname"
                    label={config.form.nickname.label}
                    fullWidth
                />

            </Grid>
            <Grid item xs={12} sm={6}>
                <Field
                    component={TextField}
                    id="phoneNumber"
                    name="phoneNumber"
                    label={config.form.phoneNumber.label}
                    type="number"
                    fullWidth
                />

            </Grid>
            <Grid item xs={12} sm={6}>
                <Field
                    component={TextField}
                    required
                    id="email"
                    name="email"
                    label={config.form.email.label}
                    type="email"
                    style={{ textAlign: 'end', direction: 'ltr' }}
                    fullWidth
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <Field
                    component={TextField}
                    required
                    id="emailVerification"
                    name="emailVerification"
                    label={config.form.emailVerification.label}
                    type="email"
                    style={{ textAlign: 'start', direction: 'ltr' }}
                    fullWidth />

            </Grid>
            <Grid item xs={12}>
                <FormControl className={classes.formControl} error={touched.subject && Boolean(errors.subject)} fullWidth>
                    <InputLabel htmlFor="subject">{config.form.subject.label}</InputLabel>
                    <Field
                        id="subject"
                        component={Select}
                        required
                        name="subject"
                        inputProps={{
                            id: 'subject',
                        }}>
                        {config.form.subject.options.map(item => (
                            <MenuItem key={item.text} value={item.value}>{item.text}</MenuItem>
                        ))}
                    </Field>
                    {
                        touched.subject && Boolean(errors.subject) ? <FormHelperText>This filed is required.</FormHelperText> : null
                    }
                </FormControl>
            </Grid>
            <Grid item xs={12}>
                <Field
                    component={TextField}
                    required
                    multiline
                    rows={12}
                    id="message"
                    name="message"
                    label={config.form.message.label}
                    fullWidth />
            </Grid>
            <Grid item xs={12}>
                <FormControl className={classes.formControl} error={'userFile' in errors} fullWidth>
                    <input ref={fileInput}
                        hidden
                        type="file"
                        id='userFile'
                        name='userFile'
                        accept=".png, .jpg"
                        onChange={onFileSelection} />
                    <Button
                        variant={Boolean(values.userFile) ? "contained" : "text"}
                        color="primary"
                        startIcon={Boolean(values.userFile) ? <Delete /> : <AttachFile />}
                        onClick={() => onSelectBtnClick(values.userFile)}>
                        {Boolean(values.userFile) ? values.userFile.name : 'Add Attachment'}
                    </Button>
                    {
                        Boolean(errors.userFile) ? <FormHelperText>{errors.userFile}</FormHelperText> : null
                    }
                </FormControl>
            </Grid>
        </>
    )
}

FormComponent.propTypes = propTypes;

export default FormComponent;